window.addEventListener('scroll', function() {
  const header = document.querySelector('.header__wrapper');
  if (window.scrollY > 0) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});



document.addEventListener("DOMContentLoaded", () => {

  const shopBtn = document.getElementById("shopBtn");
  const navMenu = document.getElementById("navMenu");

  const aboutBtn = document.getElementById("aboutBtn");
  const aboutMenu = document.getElementById("aboutMenu");

const quizBtn = document.getElementById("quizBtn");
  const quizMenu = document.getElementById("quizMenu");

  const header = document.querySelector('.header__wrapper');

  function updateHeader() {
    const isActive =
      navMenu.classList.contains('active') ||
      aboutMenu.classList.contains('active') ||
       quizMenu.classList.contains('active');

    header.classList.toggle('nav-active', isActive);
  }

  // --- SHOP MENU HOVER ---
  shopBtn.addEventListener("mouseenter", () => {
    navMenu.classList.add("active");
    updateHeader();
  });

  shopBtn.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!navMenu.matches(":hover") && !shopBtn.matches(":hover")) {
        navMenu.classList.remove("active");
        updateHeader();
      }
    }, 100);
  });

  navMenu.addEventListener("mouseleave", () => {
    if (!shopBtn.matches(":hover")) {
      navMenu.classList.remove("active");
      updateHeader();
    }
  });

  // --- ABOUT MENU HOVER ---
  aboutBtn.addEventListener("mouseenter", () => {
    aboutMenu.classList.add("active");
    updateHeader();
  });

  aboutBtn.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!aboutMenu.matches(":hover") && !aboutBtn.matches(":hover")) {
        aboutMenu.classList.remove("active");
        updateHeader();
      }
    }, 100);
  });

  aboutMenu.addEventListener("mouseleave", () => {
    if (!aboutBtn.matches(":hover")) {
      aboutMenu.classList.remove("active");
      updateHeader();
    }
  });

  
  // --- Quiz MENU HOVER ---
  quizBtn.addEventListener("mouseenter", () => {
    quizMenu.classList.add("active");
    updateHeader();
  });

  quizBtn.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!quizMenu.matches(":hover") && !quizBtn.matches(":hover")) {
        quizMenu.classList.remove("active");
        updateHeader();
      }
    }, 100);
  });

  quizMenu.addEventListener("mouseleave", () => {
    if (!quizBtn.matches(":hover")) {
      quizMenu.classList.remove("active");
      updateHeader();
    }
  });

});


document.addEventListener('DOMContentLoaded', function () {
  const searchToggle = document.querySelector('.header__icon--search');

  if (!searchToggle) return;

  searchToggle.addEventListener('click', function (e) {
    // Only apply on mobile
    if (window.innerWidth <= 768) {
      e.preventDefault();
      window.location.href = '/search';
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".pdp-mf-accordion__item");

  items.forEach(item => {
    const header = item.querySelector(".pdp-mf-accordion__header");
    const content = item.querySelector(".pdp-mf-accordion__content");
    const inner = item.querySelector(".pdp-mf-accordion__inner");

    header.addEventListener("click", () => {

      // Close other accordions
      items.forEach(other => {
        if (other !== item) {
          other.classList.remove("is-active");
          const otherContent = other.querySelector(".pdp-mf-accordion__content");
          otherContent.style.height = 0;
        }
      });

      // Toggle current
      if (item.classList.contains("is-active")) {
        item.classList.remove("is-active");
        content.style.height = 0;
      } else {
        item.classList.add("is-active");
        content.style.height = inner.scrollHeight + "px";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  var slider = tns({
    container: '.slider_inner_wrap',
    items: 1,
    slideBy: 1,
    autoplay: true,
    autoplayText:'',
    controls: true,
    controlsText:['<','>'],
    mouseDrag: true,
    autoplayHoverPause: true,
    autoplayTimeout: 6000,
  });

  const sliderWrap = document.querySelector('.header_main_slider-wrap');
  if (sliderWrap) {
    sliderWrap.style.display = 'block';
  }
});

